<template>
    <div class="user-list-tooltip" tabindex="0" :class="{active: isShowTooltipMobile}" @click="toogleTooltipInfo">
      <div class="user-list-tooltip__svg">
        <svg class="wc-i" aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></svg>
      </div>
      <div class="user-list-tooltip__wrap">
        <button class="mute-chat" v-if="isMuteChat" :title="$t('Unmute notifications')" @click="toggleMuteChat">
            <svg class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="22" x2="16" y1="9" y2="15"/><line x1="16" x2="22" y1="9" y2="15"/></svg>
            <span class="red">{{ $t("Unmute notifications") }}</span> 
        </button>
        <button v-else class="mute-chat" :title="$t('Mute notifications')" @click="toggleMuteChat">
            <svg class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>
            <span>{{ $t("Mute notifications") }}</span>             
        </button>
        <button class="mark-read" :title="$t('Mark as read')" @click="markReadAll">
            <svg class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 7 17l-5-5"/><path d="m22 10-7.5 7.5L13 16"/></svg>
            <span>{{ $t("Mark as read") }}</span>
        </button>
      </div>
      <Modal :show="showModal" @close="showModal = false" :modalClass="'chat-modal-mute'">
        <template #body>
            <span class="chat-modal-mute__icon" aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="22" x2="16" y1="9" y2="15"></line><line x1="16" x2="22" y1="9" y2="15"></line></svg>
            </span>
            <h3>{{ $t("Are you sure?") }}</h3>
            <p>{{ $t("After mute notification, you will not hear the sound of messages coming to you") }}</p>
            <div class="button-block">
                <Button
                    :isFormChanged="true"
                    :buttonText="$t('Cancel')"
                    colorClass="gray"
                    :additionalClasses="'cancel'"
                    @click="showModal = false"
                />
                <Button
                    :isFormChanged="true"
                    :buttonText="$t('Mute everyone')"
                    colorClass="yellow"
                    :additionalClasses="'mute'"
                    @click="muteAllUsers"
                />
            </div>
        </template>
      </Modal>
    </div>
  </template>
  
  <script>
import Modal from '/webpack-assets/vue/templates/chat/parts/ChatModal.vue';
import Button from '/webpack-assets/vue/components/Button.vue';
import axios from '/webpack-assets/vue/config/axios-config';
import { chatFetch } from './chatTokenManager';

export default {
  components: {
    Modal,
    Button
  },
  data() {
    return {
      isMuteChat: this.isMuteChatProp,
      showModal: false,
      isShowTooltipMobile: false,
      isSwitching: false,
      isRequestSend: false
    };
  },
  props: {
    isMuteChatProp: {
      type: Boolean,
      default: false,
    },
    testUrlQuickChat: {
      type: String,
      default: ''
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    isTablet: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    toogleTooltipInfo() {
      if(this.isTablet) this.isShowTooltipMobile = !this.isShowTooltipMobile;
    },
    toggleMuteChat() {
      if (!this.isMuteChat) {
        this.showModal = true;
      } else {
        this.switchChatNotification();
      }
    },
    async markReadAll() {
      if (this.isRequestSend) return;
      try {
        this.isRequestSend = true;
        const response = await chatFetch(`${this.testUrlQuickChat}messages/mark-read-all`, {
          method: 'GET',
        });
        if (typeof window.handleCountMarkReadAll === 'function') {
          window.handleCountMarkReadAll();
        }
        this.$emit('mark-all-read')
      } catch (e) {
        console.error('Upload error:', e);
      } finally {
        setTimeout(() => {
          this.isRequestSend = false;
        }, 500)
      }
    },
    muteAllUsers() {
      this.switchChatNotification();
      this.showModal = false;
    },
    async switchChatNotification() {
        if (this.isSwitching) return;
        this.isSwitching = true;

      try {
        const formData = new FormData();
        formData.append('_ts', Date.now());

        const response = await axios.post('/chat-api/switch-chat-notification', formData, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data.status === 'success') {
          this.isMuteChat = response.data.data === 'on' ? false : true;
          this.$emit('mute-users', this.isMuteChat);
        }
      } catch (error) {
        console.error('Request failed:', error);
      } finally {
        this.isSwitching = false;
      }
    }
  },
  watch: {
    isMuteChatProp(newVal) {
      this.isMuteChat = newVal;
    }
  }
};
</script>

<style scoped lang="scss">
  .user-list-tooltip{
    position: relative;
    &::before{
      content: '';
      pointer-events: none;
      position: absolute;
      width: 80px;
      height: 20px;
      right: 0;
      bottom: -15px;
      z-index: 99;
      background-color: transparent;
      @media only screen and (max-width: 1023px) {
        content: none;
      }
    }
    &__svg{
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: transparent;
      border-radius: 8px;
      width: 40px;
      height: 40px;
      transition: 0.4s;
      cursor: pointer;
    }
    &__wrap{
      position: absolute;
      pointer-events: none;
      opacity: 0;
      transition: 0.4s;
      transform-origin: top right;
      transform: scale(0.5);
      right: 0;
      z-index: 100;
      top: 47px;
      padding: 4px;
      background: var(--wc-surface);
      border: 1px solid var(--wc-border);
      box-shadow: 0 12px 32px var(--wc-shadow-strong);
      border-radius: 10px;
      min-width: 220px;
      &::after{
        @media only screen and (max-width: 1023px) {
          content: '';
          position: absolute;
          z-index: 1;
          height: 100vh;
          width: 100vh;
          right: -100px;
          top: -100px;
        }
      }
      .mark-read,
      .mute-chat{
        border: 0;
        border-radius: 6px;
        background-color: var(--wc-surface);
        height: 40px;
        padding: 0 10px;
        gap: 10px;
        width: 100%;
        display: flex;
        align-items: center;
        transition: 0.4s;
        position: relative;
        z-index: 2;
        svg path{
          transition: 0.4s;
        }
        span{
          font-family: var(--wc-font);
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: var(--wc-text-2);
          transition: 0.4s;
          white-space: nowrap;
          &.red{
            color: var(--wc-danger);
          }
        }
        &:hover{
          background-color: var(--wc-surface-2);
          svg path{
            fill: var(--wc-text);
          }
          span{
            color: var(--wc-text);
          }
        }
      }
    }
    &.active {
      .user-list-tooltip__wrap {
        opacity: 1;
        transform: scale(1);
        pointer-events: all;
      }
    }
    // The two actions sit inline as icon buttons on every width (design), no dots menu
    & {
      &::before{
        content: none;
      }
      .user-list-tooltip__svg{
        display: none;
      }
      .user-list-tooltip__wrap{
        // no tap-outside catcher: the actions are always visible now
        &::after{
          content: none !important;
        }
        position: static;
        display: flex;
        gap: 4px;
        min-width: 0;
        padding: 0;
        border: 0;
        background: transparent;
        opacity: 1;
        transform: none;
        pointer-events: all;
        box-shadow: none;
        border-radius: 0;
        .mark-read,
        .mute-chat{
          width: 32px;
          height: 32px;
          @media only screen and (max-width: 1023px) {
            width: 40px;
            height: 40px;
          }
          padding: 0;
          border: 0;
          border-radius: 8px;
          justify-content: center;
          background-color: transparent;
          svg{
            width: 18px;
            height: 18px;
          }
          span{
            display: none;
          }
          &:hover{
            background-color: var(--wc-bg);
          }
        }
        .mute-chat:has(.red) svg path{
          fill: var(--wc-danger);
        }
      }
    }
  }
</style>

<style lang="scss">
  // Confirm dialog (design P-Mute): no title bar, icon + text + two buttons
  .chat-modal-mute{
      max-width: 400px !important;
      .modal-header{
          height: 0 !important;
          padding: 0 !important;
          border: 0 !important;
          .modal-button--close{
              display: none;
          }
      }
      .modal-body{
          padding: 24px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 8px;
          text-align: center;
      }
      &__icon{
          width: 48px;
          height: 48px;
          margin-bottom: 4px;
          border-radius: 12px;
          background: #FEF6E7;
          color: #B45309;
          display: flex;
          align-items: center;
          justify-content: center;
      }
      h3{
          margin: 0;
          padding: 0;
          font-family: var(--wc-font-heading);
          font-weight: 400;
          font-size: 18px;
          line-height: 24px;
          text-transform: none;
          color: var(--wc-text);
      }
      p{
          margin: 0;
          font-family: var(--wc-font);
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: var(--wc-text-2);
      }
      .button-block{
          display: flex;
          gap: 8px;
          width: 100%;
          margin-top: 12px;
          .button{
              flex: 1;
              max-width: 100%;
              height: 44px;
              margin: 0;
              padding: 0 16px;
              display: flex;
              align-items: center;
              justify-content: center;
              line-height: 20px;
              border-radius: 8px;
              font-family: var(--wc-font-medium);
              font-size: 14px;
              text-transform: none;
              &.cancel{
                  background: var(--wc-surface) !important;
                  border: 1px solid var(--wc-border) !important;
                  color: var(--wc-text) !important;
              }
              &.mute{
                  background: var(--wc-brand) !important;
                  border: 0 !important;
                  color: #13192A !important;
              }
          }
      }
  }
</style>